import { KiloClassPayRateLookup, AppointmentPayRateLookup, OtherWorkPayRateLookup } from 'types';

export type KiloClassPayRateLookupType = {
  [key: string]: KiloClassPayRateLookup;
};

export type AppointmentPayRateLookupType = {
  [key: string]: AppointmentPayRateLookup;
};

export type OtherWorkPayRateLookupType = {
  [key: string]: OtherWorkPayRateLookup;
};

export const getClassTypeRoleToPayRateLookup = (
  classPayRateLookups: KiloClassPayRateLookup[],
): KiloClassPayRateLookupType => {
  const payRateLookup: KiloClassPayRateLookupType = {};

  classPayRateLookups.forEach(lookup => {
    const key = `${lookup.kiloClassType}-${lookup.kiloClassCoachRole}`;
    payRateLookup[key] = lookup;
  });

  return payRateLookup;
};

export const getAppointmentTypeRoleToPayRateLookup = (
  appointmentPayRateLookups: AppointmentPayRateLookup[],
): AppointmentPayRateLookupType => {
  const payRateLookup: AppointmentPayRateLookupType = {};

  appointmentPayRateLookups.forEach(lookup => {
    const key = `${lookup.appointmentType}-${lookup.appointmentCoachRole}`;
    payRateLookup[key] = lookup;
  });

  return payRateLookup;
};

export const getOtherWorkTypeToPayRateLookup = (
  otherWorkPayRateLookups: OtherWorkPayRateLookup[],
): OtherWorkPayRateLookupType => {
  const payRateLookup: OtherWorkPayRateLookupType = {};

  otherWorkPayRateLookups.forEach(lookup => {
    const key = `${lookup.otherWorkType}`;
    payRateLookup[key] = lookup;
  });

  return payRateLookup;
};
